import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum ScheduledActivityTypeId {
  PERSONAL_MEETING = 'personal-meeting',
  ONLINE_MEETING = 'online-meeting',
  CALL = 'call',
  EMAIL = 'email',
  OFFER = 'offer',
  OTHER = 'other',
}

export class ScheduledActivityType extends Codebook<ScheduledActivityTypeId> {
  static readonly PERSONAL_MEETING = new ScheduledActivityType(
    ScheduledActivityTypeId.PERSONAL_MEETING,
    () => $t('Personal meeting'),
    'user-group',
  )

  static readonly ONLINE_MEETING = new ScheduledActivityType(
    ScheduledActivityTypeId.ONLINE_MEETING,
    () => $t('Online meeting'),
    'headset',
  )

  static readonly CALL = new ScheduledActivityType(
    ScheduledActivityTypeId.CALL,
    () => $t('Call'),
    'phone',
  )

  static readonly EMAIL = new ScheduledActivityType(
    ScheduledActivityTypeId.EMAIL,
    () => $t('Email'),
    'envelope',
  )

  static readonly OFFER = new ScheduledActivityType(
    ScheduledActivityTypeId.OFFER,
    () => $t('Offer'),
    'hand-holding-dollar',
  )

  static readonly OTHER = new ScheduledActivityType(
    ScheduledActivityTypeId.OTHER,
    () => $t('Other'),
    'triangle-exclamation',
  )

  private constructor(
    id: ScheduledActivityTypeId,
    public readonly name: () => string,
    public readonly icon: string,
  ) {
    super(id)
  }
}
